import { fetchDataControl, fetchingData } from "../../api";
import axios from "../../axios";

const url = "/api/ceklist-monitoring-value";

// Ceklis Monitoring
// index
export const fetchCeklistMonitoringValue = async (page = 1, custom = "") => {
  return await fetchDataControl(async () => {
    return await axios.get(`${url}?page=${page}&${custom}`);
  });
};
// show
export const showCeklistMonitoringValue = async (id, custom = "") => {
  return await fetchDataControl(async () => {
    return await axios.get(`${url}/${id}?${custom}`);
  });
};
// store
export const postCeklistMonitoringValue = async (data) => {
  fetchingData();
  return await fetchDataControl(async () => {
    return await axios.post(`${url}`, data);
  });
};
// update
export const patchCeklistMonitoringValue = async (id, data, custom = "") => {
  fetchingData();
  return await fetchDataControl(async () => {
    return await axios.patch(`${url}/${id}?${custom ? custom : ""}`, data);
  });
};
// delete
export const deleteCeklistMonitoringValue = async (id, custom = "") => {
  fetchingData();
  return await fetchDataControl(async () => {
    return await axios.delete(`${url}/${id}&${custom}`);
  });
};
